import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailRowsCard } from 'UI';

type BankDetailsCardProps = {
  details: {
    AccountNumber: string;
  } & (
    | {
        ABARoutingNumber: string;
        FinancialInstitutionNumber?: never;
        BranchTransitNumber?: never;
      }
    | {
        FinancialInstitutionNumber: string;
        BranchTransitNumber: string;
        ABARoutingNumber?: never;
      }
  );
};

export default function BankDetailsCard({ details }: BankDetailsCardProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Transaction.TransactionHistory.Details.BankDetailsCard' });

  const bankAccountDetails = useMemo(() => {
    if (details.ABARoutingNumber) {
      return [
        {
          label: t('abaRoutingNumber', { defaultValue: 'ABA Routing Number' }),
          value: details.ABARoutingNumber || '-',
        },
        {
          label: t('accountNumber', { defaultValue: 'Account Number' }),
          value: details.AccountNumber.replaceAll('*', '•') || '-',
        },
      ];
    }

    return [
      {
        label: t('financialInstitutionNumber', { defaultValue: 'Financial Institution Number' }),
        value: details.FinancialInstitutionNumber || '-',
      },
      {
        label: t('branchTransitNumber', { defaultValue: 'Branch Transit Number' }),
        value: details.BranchTransitNumber?.replaceAll('*', '•') || '-',
      },
      {
        label: t('accountNumber', { defaultValue: 'Account Number' }),
        value: details.AccountNumber?.replaceAll('*', '•') || '-',
      },
    ];
  }, [details]);

  return <DetailRowsCard title={t('title', { defaultValue: 'Bank Account Details' })} details={bankAccountDetails} />;
}
